import React from "react";
import Register from './components/Register'

export default function RegisterApp(props) {
  return <Register {...props} />;
}

